// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__pPzOe","fadeOut":"Preloader_fadeOut__Nai7a"};